export default __webpack_public_path__ + "static/header-img-7c3bf92f5a1dd1bfb17a6740c26fc94b.png";